module.exports = {"loadingText":"Načítám konfigurační data pro modul Portfolio","loadingGroupInfo":"Načítám informace o skupině"}